<script setup>
// 首頁自己是整屏捲動容器（layout: false），不吃這個版型；
// 其餘頁面（會員中心、版本資訊、第三方回調、錯誤頁）共用活動站的頁首與頁尾。
// 頁尾的山稜線只適合疊在淺色裝飾區塊上，這裡上方是內容區，關掉。
</script>

<template>
  <div class="layout">
    <SiteHeader />
    <main class="layout-main">
      <div class="layout-inner">
        <slot />
      </div>
    </main>
    <SiteFooter :ridge="false" />
  </div>
</template>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: var(--site-font);
  color: var(--site-ink);
  background: #fff;
}

.layout-main {
  flex: 1;
  padding: 48px 0 64px;
  background: linear-gradient(180deg, #fffaf3 0%, #ffffff 320px);
}

.layout-inner {
  max-width: var(--site-max);
  margin: 0 auto;
  padding: 0 20px;
}

@media (max-width: 900px) {
  .layout-main {
    padding: 28px 0 40px;
  }
}
</style>
